import React from "react";

const File = ({ onClick }: { onClick?: () => void }) => (
  <svg
    cursor={"pointer"}
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M9.2085 1.41699H4.25016C3.87444 1.41699 3.5141 1.56625 3.24843 1.83192C2.98275 2.0976 2.8335 2.45794 2.8335 2.83366V14.167C2.8335 14.5427 2.98275 14.903 3.24843 15.1687C3.5141 15.4344 3.87444 15.5837 4.25016 15.5837H12.7502C13.1259 15.5837 13.4862 15.4344 13.7519 15.1687C14.0176 14.903 14.1668 14.5427 14.1668 14.167V6.37533L9.2085 1.41699Z"
      stroke="#272727"
      strokeWidth="1.17241"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.2085 1.41699V6.37533H14.1668"
      stroke="#272727"
      strokeWidth="1.17241"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default React.memo(File);
